import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ContentBlockRecord } from "../../ContentBlocksPage.utils";
import { saveContentBlockDetails } from "../../ContentBlocksPage.service";
import styles from "./ActionsRenderer.module.css";

interface ActionRendererProps {
  data: ContentBlockRecord;
  onView: (data: ContentBlockRecord) => void;
  onEdit: (data: ContentBlockRecord) => void;
  onDelete: () => void;
}

const ActionRenderer: React.FC<ActionRendererProps> = ({ 
  data, 
  onView, 
  onEdit, 
  onDelete 
}) => {
  
  const handleDeleteClick = async () => {
    const success = await saveContentBlockDetails({...data, Active: "N", Operation: "delete"});
    if (success) {
      onDelete();
    }
  };

  return (
    <div>
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="button-tooltip">Edit content block</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={`${styles.editActionButton} ${styles.actionButton}`}
            onClick={() => onEdit(data)}
          >
            <Icon.PencilSquare />
          </Button>
        </span>
      </OverlayTrigger>

      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="button-tooltip">View content block</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={`${styles.viewButton} ${styles.actionButton}`}
            onClick={() => onView(data)}
          >
            <Icon.Eye />
          </Button>
        </span>
      </OverlayTrigger>

      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="button-tooltip">Delete content block</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={`${styles.deleteActionButton} ${styles.actionButton}`}
            onClick={handleDeleteClick}
          >
            <Icon.Trash />
          </Button>
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default ActionRenderer;